import React from "react";

import styled from "styled-components";

const AuthWrapper = () => {
  return <h4>AuthWrapper Component</h4>;
};

const Wrapper = styled.section`
  min-height: 100vh;
  display: grid;
  place-items: center;
`;

export default AuthWrapper;
